import { render, staticRenderFns } from "./CoreInput.vue?vue&type=template&id=0bbfdef4&scoped=true&"
import script from "./CoreInput.vue?vue&type=script&lang=js&"
export * from "./CoreInput.vue?vue&type=script&lang=js&"
import style0 from "./CoreInput.vue?vue&type=style&index=0&id=0bbfdef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbfdef4",
  null
  
)

export default component.exports